// import useAuth from "../../../hooks/useAuth";
import { features } from "@/components/qashqool/LandingPageData";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";
import {
  BookOpen,
  Trophy,
  Video
} from "lucide-react";
import { useState } from "react";
import { useAppSelector } from "../../../store/hooks";
import LoginForm from "../LoginForm";
import RegistrationForm from "../RegistrationForm";

const GeneralTeacherTemp = () => {
  const { user, portal } = useAppSelector((state) => state.store);
  const [activeTab, setActiveTab] = useState("login");

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-(--secondary-color)/10 to-yellow-50 pt-4">
      {/* Hero Section */}
      <section className="relative overflow-hidden py-8 ">
        {/* Sophisticated Background */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 left-10 w-96 h-96 bg-gradient-to-br from-cyan-50 to-green-100 rounded-full blur-3xl opacity-60"></div>
          <div className="absolute bottom-1/4 right-10 w-80 h-80 bg-gradient-to-tl from-purple-50 to-blue-50 rounded-full blur-3xl opacity-50"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start">
            {/* Left Column - Content */}
            <div className="lg:col-span-7 text-center lg:text-left flex flex-col gap-6">
              <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-5xl font-bold text-gray-900 mb-2  text-start w-fit mx-auto">
                <span className="bg-gradient-to-r from-(--primary-color-dark)/90 via-primary/90 to-(--primary-color-dark)/90 bg-clip-text text-transparent block mb-2 text-start py-2">
                  المذاكرة بقت أقرب و أسهل
                </span>
              </h1>
              <div
                id="auth-form"
                className={cn(
                  "shadow-lg w-fit mx-auto flex flex-col gap-4 overflow-hidden rounded-lg bg-white transition-all duration-200",
                  activeTab === "signup" ? "w-full" : "md:w-2/3 w-full"
                )}
              >
                <div className="flex flex-row gap-0">
                  <Button
                    onClick={() => setActiveTab("login")}
                    className={cn(
                      "grow rounded-none rounded-bl-lg shadow-none",
                      activeTab === "login"
                        ? "bg-primary text-white"
                        : "bg-transparent hover:bg-trasnparent text-primary"
                    )}
                  >
                    تسجيل الدخول
                  </Button>
                  <Button
                    onClick={() => setActiveTab("signup")}
                    className={cn(
                      "grow rounded-none rounded-br-lg shadow-none",
                      activeTab === "signup"
                        ? "bg-primary text-white hover:bg-primary/90"
                        : "bg-transparent hover:bg-trasnparent text-primary"
                    )}
                  >
                    إنشاء حساب
                  </Button>
                </div>
                <div className="w-full p-6" dir="ltr">
                  {activeTab === "login" ? <LoginForm /> : <RegistrationForm />}
                </div>
              </div>
            </div>
            {/* <div className="lg:col-span-7 text-center lg:text-left">
              <div className="mb-8">
                <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-gray-900 mb-8 leading-[1.1] text-start">
                  <span className="block">ارتقِ بـ</span>
                  <span className="bg-gradient-to-r from-blue-600 via-primary to-purple-600 bg-clip-text text-transparent block mb-2 text-start">
                    رحلتك الأكاديمية
                  </span>
                  <span className="text-gray-700 font-semibold text-3xl md:text-4xl lg:text-5xl text-start">
                    مع إرشاد احترافي
                  </span>
                </h1>

                <div className="max-w-2xl">
                  <p className="text-lg md:text-xl text-gray-600 mb-10 leading-relaxed text-start">
                    حوّل إمكاناتك الأكاديمية من خلال منصتنا الشاملة. احصل على
                    محاضرات يقودها خبراء، جلسات تفاعلية، ومسارات تعلم شخصية
                    مصممة من أجل{" "}
                    <span className="font-semibold text-gray-900 ">
                      التميز في المرحلة الثانوية
                    </span>
                    .
                  </p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-16">
                <Button
                  size="lg"
                  asChild
                  className="bg-gradient-to-r from-blue-600 to-primary hover:from-blue-700 hover:to-primary text-lg px-10 py-4 shadow-lg hover:shadow-xl transition-all duration-300 border-0"
                >
                  <Link to="/auth">
                    <UserPlus className="w-5 h-5 mr-2" />
                    ابدأ رحلتك
                  </Link>
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  asChild
                  className="text-lg px-10 py-4 border-2 border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-all duration-300"
                >
                  <Link to={user ? "/" : "/auth"}>
                    <BookOpen className="w-5 h-5 mr-2" />
                    استكشف المحتوى
                  </Link>
                </Button>
              </div>
            </div> */}

            {/* Right Column - Professional Image */}
            <div className="lg:col-span-5 flex justify-center lg:justify-end mt-12">
              <div className="relative max-w-md">
                {/* Main educator image */}
                <div className="relative group">
                  <div className="absolute -inset-8 bg-gradient-to-r from-blue-100 via-indigo-100 to-purple-100 rounded-3xl blur-2xl opacity-30 group-hover:opacity-40 transition-opacity duration-700"></div>
                  <div className="relative">
                    <img
                      src={portal.profile_pic}
                      alt={portal.name}
                      className="w-80 h-80 lg:w-96 lg:h-96 rounded-3xl object-cover shadow-2xl border-4 border-white/50 backdrop-blur-sm transition-all duration-500 group-hover:shadow-3xl"
                    />

                    {/* Subtle achievement indicator */}
                    <div className="absolute -bottom-6 -right-6 w-16 h-16 bg-gradient-to-br from-emerald-500 to-green-600 rounded-2xl flex items-center justify-center border-4 border-white shadow-xl">
                      <Trophy className="w-7 h-7 text-white" />
                    </div>
                  </div>

                  {/* Professional credentials */}
                  <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                    <div className="bg-white/95 backdrop-blur-sm p-3 rounded-2xl shadow-lg border border-(--primary-color-light)/50 min-w-fit">
                      <span className="text-lg font-semibold text-primary whitespace-nowrap">
                        {portal.name}
                      </span>
                    </div>
                  </div>

                  {/* Floating academic elements */}
                  <div className="absolute top-8 -left-8 w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg opacity-90">
                    <BookOpen className="w-6 h-6 text-white" />
                  </div>
                  <div className="absolute bottom-16 -left-6 w-10 h-10 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg flex items-center justify-center shadow-lg opacity-90">
                    <Video className="w-5 h-5 text-white" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              كل ما تحتاجه لتتفوق
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              منصتنا الشاملة توفر لك جميع الأدوات والموارد التي تحتاجها للتميز
              الأكاديمي
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <Card
                  key={index}
                  className="hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-0 shadow-md"
                >
                  <CardHeader className="pb-4">
                    <div className="flex items-center justify-between mb-4">
                      <div
                        className={`w-14 h-14 ${feature.color} rounded-xl flex items-center justify-center`}
                      >
                        <Icon className="w-7 h-7" />
                      </div>
                      <Badge variant="secondary" className="text-xs">
                        {feature.badge}
                      </Badge>
                    </div>
                    <CardTitle className="text-xl font-semibold">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-gray-600 leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GeneralTeacherTemp;
